import lodashDebounce from 'lodash/debounce';
import lodashRemove from 'lodash/remove';
import lodashClone from 'lodash/clone';
import lodashCloneDeep from 'lodash/cloneDeep';
import utils from 'libs/utils.js';
import {Grid as GridSecurity} from 'libs/classes/security.js';
import { ContextMenuItem } from 'libs/classes/grid';
import { LocalStorage } from 'libs/clientstorage';
import ExtendedGridController from 'controller/extendedgridcontroller.js';
import { GridController } from 'controller/gridcontroller';

export default {
  props: {
    config: Object,
    filters: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    contextMenuItems: {
      type: Array,
      default: () => []
    },
    forcedFilters: Array,
    forcedPageSize: {
      type: Number,
      default: 35
    },
    showFilterBar: {
      type: Boolean,
      default: true
    },
    wrapperDivId: {
      type: String,
      default: ''
    },
    autoLoad: {
      type: Boolean,
      default: true
    },
    dateFilters: {
      type: Array,
      default: function() {
        return [];
      }
    },
    controlName: {
      type: String,
      default: 'default'
    },
    disableUrlFilters: {
      // exclude url params from datafilter
      default: false
    },
    defaultDataSource: {
      type: Number,
      default: null
    },
    selectFirstRowOnMounted: {
      type: Boolean,
      default: false
    },
    // Emits the single-row-checked event
    emitSelectOnRow: {
      type: Boolean,
      default: false
    },
    defaultSearchExpressions: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      isMobile: false,
      searchExpressions: { SEARCH: '' },
      gridData: [],
      gridDataMeta: [],
      gridCols: [],
      flexGridLayout: [],
      urlFilters: [],
      selectedPage: 1,
      allSelected: false,
      columnFilter: null,
      dataFilter: {},
      selectedLayoutID: this.config.selectedLayoutID,
      controlLayoutName: this.config.controlName,
      selectedDataSource: 0,
      orderBy: '',
      loader: {
        isBusy: false,
        loadingMessage: ''
      },
      totalResults: 1,
      contextMenuItemsForRow: [],
      baseContextMenuItems: [],
      gridcontroller: null,
      isLoaded: false,
      allowChangeSystemViews: false,
      allowChangeUserViews: false,
      layoutName: null,
      complexFilters: [],
      pinnedFilter: false
    };
  },
  async created() {
    const store = new LocalStorage(this.controlName + '-filtersettings');
    this.pinnedFilter = store.get('pinned', false);

    this.allowChangeSystemViews = await this.$authorize(
      GridSecurity.AllowChangeSystemViews
    );
    this.allowChangeUserViews = await this.$authorize(
      GridSecurity.AllowChangeUserViews
    );
    this.$log(
      'get grid settings',
      this.allowChangeSystemViews,
      this.allowChangeUserViews
    );
  },
  methods: {
    showHelp: function() {
      console.log('### BESCHIKBARE FILTERS ###');
      this.gridcontroller
        .GetAvailableFiltersForPage()
        .then(res => {
          console.log(res);
        })
        .catch(error =>
          console.error('failed to get available columns', error)
        );
    },
    openDefaultContextMenu: function(event) {
      this.listItemClickedRight({ event: event, obj: null });
    },
    listItemClicked: function(val) {
      const ls = window.sessionStorage;
      if (ls != null) {
        ls.setItem('last-opened-' + this.controlName, val.obj);
      }
      this.$emit('list-item-clicked', val);
      if (this.config.onListItemClicked != null) {
        this.config.onListItemClicked(val.obj);
      }
    },
    listItemClickedRight: function(val) {
      // val.event = event;
      // val.obj = object selected
      // val.type = 'row' or 'col'
      this.$refs.menu.open(val.event, { obj: val.obj, type: val.type });
    },
    contextMenuClosed: function() {
      // deselect selected item (only if one is selected (for user experience))
      let selected = this.getSelectedRows();
      if (selected.length === 1) {
        selected[0].selected = false;
      }
    },
    refreshContextMenu: function(ev) {
      // load context menu
      const showFunc = () => (this.allowChangeSystemViews || this.allowChangeUserViews);

      const showFieldDictionary = new ContextMenuItem(
        this.$t('grid.columns'),
        this.$refs.fieldDictionary.showModal
      );
      showFieldDictionary.showItemFunc = showFunc;

      const viewManager = new ContextMenuItem(
        this.$t('view.view_manager'),
        this.$refs.flexGridLayoutSearch.showModal
      );
      const saveView = new ContextMenuItem(
        this.$t('view.save_view'),
        this.saveCurrentLayout
      );
      const saveViewAs = new ContextMenuItem(
        this.$t('view.save_view_as'),
        this.saveCurrentLayoutAs
      );
      saveView.showItemFunc = () =>
        (this.allowChangeSystemViews && this.flexGridLayout.LayoutType === 0) ||
        (this.allowChangeUserViews && this.flexGridLayout.LayoutType === 1);
      
      saveViewAs.showItemFunc = () => (this.allowChangeSystemViews || this.allowChangeUserViews);

      const viewSubMenu = [viewManager, saveView, saveViewAs];
      const viewSettings = new ContextMenuItem(this.$t('settings'));
      viewSettings.showItemFunc = showFunc;
      viewSettings.children = viewSubMenu;
      viewSettings.showFunc = showFunc;
      this.baseContextMenuItems = [showFieldDictionary, viewSettings];

      let self = this;
      let dynamicContextMenu = [];
      let contextMenuResult = [];

      if (ev != null && ev.type === 'col') {
        let colInfo = ev.obj[1];
        if (!utils.isColumnSearchDisabled(colInfo)) {
          let gridDefaults = [
            { title: this.$t('grid.quick_filter'), method: self.quickFilter }
          ];
          contextMenuResult.push(...gridDefaults);
        }
      }

      let contextMenuFromProp = self.contextMenuItems
        ? lodashCloneDeep(self.contextMenuItems)
        : [];

      let rowselected = ev.obj !== null;
      if (contextMenuFromProp.length > 0 && rowselected === false) {
        contextMenuFromProp = contextMenuFromProp.filter(
          x => x.forRow === false || (x.forRow === true && rowselected === true)
        );
      }

      if (self.multipleSelected) {
        // only show menu items that allow multi select (batch) actions.
        dynamicContextMenu = contextMenuFromProp.filter(
          x => x.allowMultiSelect === true
        );

        if (dynamicContextMenu.length > 0) {
          for (let item of dynamicContextMenu) {
            if (item.children && item.children.length > 0) {
              item.children = item.children.filter(
                x => x.allowMultiSelect === true
              );
            }
          }
        }
      } else {
        dynamicContextMenu = contextMenuFromProp;
      }

      if (dynamicContextMenu.length > 0) {
        contextMenuResult.push(...dynamicContextMenu);
      }

      this.contextMenuItemsForRow = contextMenuResult;
    },
    onContextItemClicked: function(item, data) {
      let selected = this.getSelectedRows(); // multi selected rows
      if (item.method) {
        if (item.allowMultiSelect && selected.length > 0) {
          item.method(selected, data);
        } else {
          // the object that sent the event
          item.method(data.data.obj);
        }
      }

      this.$refs.menu.close();
    },
    getDataLive: lodashDebounce(function(reloadColumns, search = true) {
      this.getData(reloadColumns, search);
    }, 500),
    getData: function(reloadColumns, search = true) {
      this.allSelected = false; // reset checkboxes
      let self = this;

      if (search) {
        self.selectedPage = 1;
      }

      let datafilter = this.getFetchFilter();
      this.saveState();
     
      this.$set(this.loader, 'isBusy', true);
      let now = new Date();

      this.gridcontroller
        .GetFlexData(datafilter)
        .then(res => {
          self.totalResults = parseInt(res.Meta.Count);
          if (search) {
            // replace all data
            self.gridData = res.Data;
          } else {
            // loadmore
            self.gridData.push(...res.Data);
          }
          this.$refs.grid.updateRows(self.gridData, search);

          self.showLoadMore = self.pageSize === res.Data.length;
          self.gridDataMeta = res.Meta;

          if (reloadColumns) {
            self.gridCols = self.mapLayout(
              this.getFilteredLayoutColumns(self.gridCols),
              res.Meta.Columns
            );
          }
        })
        .catch(error =>
          self.showAlert(this.$t('errors.error_retrieving'), error)
        )
        .finally(() => {
          this.$set(
            this.loader,
            'loadingMessage',
            this.$t('grid.result_msg', {
              0: self.totalResults,
              1: Math.abs(new Date() - now) / 1000
            })
          );
          this.$set(this.loader, 'isBusy', false);
        });
    },
    getLayoutAndData: function() {
      this.getFlexLayout(this.getData);
    },
    refreshCurrentDataSet: function() {
      this.getDataLive();
      // reloadColumns = false, search = false, refresh = true
      // this.getDataLive(false, false, true);
    },
    saveCurrentLayout: function() {
      const self = this;
      let obj = {
        AutoID: this.flexGridLayout.AutoID,
        FlexGridLayout: {
          Columns: this.getFilteredLayoutColumns(self.gridCols),
          PageSize: self.pageSize,
          Sort: self.orderBy
        }
      };
      this.gridcontroller
        .UpdateFlexGridLayout(obj)
        .then(res => {})
        .catch(error => self.showAlert(this.$t('errors.error_saving'), error))
        .finally(() => {
          this.$set(this.loader, 'isBusy', false);
        });
    },
    saveCurrentLayoutAs: function() {
      const self = this;
      let obj = {
        FlexGridLayout: {
          Columns: self.getFilteredLayoutColumns(self.gridCols),
          PageSize: self.pageSize,
          Sort: self.orderBy
        },
        ControlName:
          self.controlLayoutName !== null ? self.controlLayoutName : ''
      };

      self.$refs.editLayout.showModal(obj);
    },
    /**
     * Get filter to retrieve data
     * @param  {boolean} refresh
     */
    getFetchFilter: function(refresh) {
      let self = this;

      let obj = {
        filter: {
          dataSource: self.selectedDataSource,
          pageIndex: refresh ? 0 : self.selectedPage - 1,
          pageSize: refresh ? self.selectedPage * self.pageSize : self.pageSize,
          order: self.orderBy,
          searchExpressions: self.searchExpressions,
          flexGridLayoutColumns: self.getFilteredLayoutColumns(self.gridCols),
          dataFilter: self.computedDataFilter(),
          operatorFilter: self.computedOperatorFilter(),
          columnFilter: self.columnFilter
        }
      };
      return obj;
    },
    searchExpressionChanged: function(val) {
      this.searchExpressions['SEARCH'] = val;
      this.searchChanged();
    },
    searchChanged: function() {
      this.gotoPage(1);
      this.getDataLive();
    },
    getFlexLayout: async function(callbackF) {
      const self = this;
      self.$set(self.loader, 'isBusy', true);

      if (self.selectedLayoutID) {
        let obj = { AutoID: self.selectedLayoutID };

        this.gridcontroller
          .GetFlexGridLayout(obj)
          .then(data => {
            let name = data.Name;
            self.layoutName =
              name == null || name === 'default'
                ? this.$t('grid.standard_view')
                : name;
            self.isLoaded = true;
            self.flexGridLayout = data;
            self.gridCols = data.Columns;

            this.$set(self, 'pageSize', data.PageSize);
            this.$set(self, 'orderBy', data.Sort);

            if (callbackF != null) {
              callbackF(true);
            }
          })
          .catch(error =>
            self.showAlert(this.$t('errors.error_retrieving'), error)
          )
          .finally(() => {
            this.$set(this.loader, 'isBusy', false);
          });
      } else {
        // no layout set initially, get default layout for user
        let obj = {
          controlName:
            self.controlLayoutName !== null ? self.controlLayoutName : ''
        };

        this.gridcontroller
          .GetUserFlexGridLayout(obj)
          .then(data => {
            let name = data.Name;
            self.layoutName =
              name == null || name === 'default'
                ? this.$t('grid.standard_view')
                : name;

            self.isLoaded = true;
            self.flexGridLayout = data;
            self.gridCols = data.Columns;
            this.$set(self, 'orderBy', data.Sort);
            self.selectedLayoutID = data.AutoID;

            if (callbackF != null) {
              callbackF(true);
            }
          })
          .catch(error =>
            self.showAlert(this.$t('errors.error_retrieving'), error)
          )
          .finally(() => {
            this.$set(this.loader, 'isBusy', false);
          });
      }
    },
    changeLayout: function(item) {
      this.selectedLayoutID = item.AutoID;
      this.getFlexLayout(this.getData);
    },
    layoutDeleted: function(item) {
      if (this.selectedLayoutID === item.AutoID) {
        this.selectedLayoutID = null;
        this.getFlexLayout(this.getData);
      }
    },
    quickFilter: function(data) {
      this.$refs.grid.quickFilter(data);
    },
    mapLayout: function(layout, metadata) {
      const self = this;
      let reduced = layout.reduce((acc, x) => {
        let toAssign = null;
        let meta = metadata
          ? metadata.find(me => x.FieldName === me.FieldName)
          : null;
        if (!meta) {
          console.warn('requested column not found: ', x);
          return acc;
        }
        toAssign = lodashClone(meta);

        // set column search values
        let existingSearch = '';
        if (self.columnFilter) {
          let found = self.columnFilter.find(
            col => x.FieldName === col.FieldName
          );
          existingSearch = found ? found.Search : '';
        }

        let existingColumnAdvancedFilter = null;
        if(self.complexFilters) {
          let found = self.complexFilters.filter(
            col => x.FieldName === col.selector
          );
          existingColumnAdvancedFilter = found ? found : [];
        }

        let newX = {
          FieldName: x.FieldName,
          ColumnWidth: x.ColumnWidth,
          ColumnAlignment: x.ColumnAlignment,
          Visible: x.Visible,
          Search: existingSearch,
          AdvancedFilters: existingColumnAdvancedFilter
        };

        let newObj = Object.assign(toAssign, newX);
        acc.push(newObj);

        return acc;
      }, []);
      return reduced;
    },
    gotoPage: function(pageid) {
      this.selectedPage = pageid;
      this.getDataLive();
    },
    setSortOption: function(sort) {
      this.orderBy = sort.column + ' ' + sort.direction;
      this.getData();
    },
    allSelectToggled: function() {
      this.allSelected = !this.allSelected;
      this.$emit('all-select-toggled');
    },
    showColumnsModal: function() {
      this.$refs.columnSearch.showModal();
    },
    onFlexGridChanged: function(items) {
      let self = this;
      if (items.Deleted.length > 0) {
        for (let item of items.Deleted) {
          let existing = self.gridCols.find(
            m => m.FieldName === item.FieldName
          );
          lodashRemove(self.gridCols, function(n) {
            return n.FieldName === existing.FieldName;
          });
        }
      }
      if (items.Added.length > 0) {
        for (let item of items.Added) {
          item.Visible = true;
          item.ColumnWidth = 150;
          self.gridCols.push(item);
        }
      }
      if (items.Updated.length > 0) {
        for (let item of items.Updated) {
          let existing = self.gridCols.find(
            m => m.FieldName === item.FieldName
          );
          existing.ColumnAlignment = item.ColumnAlignment;
        }
      }
      this.getData(true);
    },
    toPixels: function(str) {
      return str + 'px';
    },
    /**
     * Get all values from external list-input filters
     * merge external filters with url parameter-filters
     */
    computedDataFilter: function() {
      let mergedFilters = [...this.filters];
      if (!this.disableUrlFilters) mergedFilters.push(...this.urlFilters);
      if (this.forcedFilters) {
        mergedFilters.push(...this.forcedFilters);
      }
      var dataFilter = {};
      for (var item of mergedFilters.filter(x => x.selectedKey != null)) {
        dataFilter[item.selector] = item.selectedKey;
      }
      return dataFilter;
    },
    /**
     * Get all values from external operator filters like date filters
     */
    computedOperatorFilter: function() {
      let operatorFilter = [];
      let filters = this.dateFilters;
      for (let item of filters.filter(x => x.selectedDate != null)) {
        if (utils.isValidDate(new Date(item.selectedDate))) {
          operatorFilter.push({
            FieldName: item.selector,
            Value: new Date(item.selectedDate),
            Operator: item.operator
          });
        }
      }
      filters = this.complexFilters;
      for(let item of filters) {
        operatorFilter.push({
          FieldName: item.selector,
          Value: item.value,
          Operator: item.operator
        });
      }
      return operatorFilter;
    },
    // Triggered when filtering the column search
    gridColumnFiltered(filter) {
      this.columnFilter = filter;
      this.gotoPage(1);
    },
    gridColumnFilteredAdvanced(filter) {
      this.complexFilters = filter;
      this.gotoPage(1);
    },
    // Triggered when filtering an external list-input filter
    filterKeyChanged: function(filter, val) {
      // filter.selectedKey = val;
      this.gotoPage(1);
    },
    showAlert: function(msg, error) {
      console.error(error, this.$refs.alertbox);
      this.$refs.alertbox.showError(msg);
    },
    getFilteredLayoutColumns: function(raw) {
      let result = raw.map(x => {
        return {
          Visible: x.Visible,
          ColumnWidth: x.ColumnWidth,
          ColumnAlignment: x.ColumnAlignment,
          FieldName: x.FieldName
        };
      });
      return result;
    },
    setPinnedFilter (enabled) {
      this.pinnedFilter = enabled;
      const store = new LocalStorage(this.controlName + '-filtersettings');
      store.save('pinned', enabled);
      if (enabled) {
        this.saveStorageState();
      } else {
        this.clearStorageState();
      }
    },
    getStoreKey (pinFilter) {
      let result = 'last-filter-' + this.controlName;
      if (!pinFilter) {
        result += '-' + btoa(window.location.href.replace(window.location.origin, ''));
      }
      return result;
    },
    coreSaveState: function () {
      let self = this;
      let state = {
        filter: {
          dataSource: self.selectedDataSource,
          pageIndex: self.selectedPage - 1,
          pageSize: self.pageSize,
          order: self.orderBy,
          searchExpressions: self.searchExpressions,
          flexGridLayoutColumns: this.getFilteredLayoutColumns(self.gridCols),
          dataFilter: self.computedDataFilter(),
          columnFilter: self.columnFilter,
          urlFilters: self.urlFilters,
          dateFilters: self.dateFilters,
          complexFilters: self.complexFilters
        },
        controller: self.gridcontroller
      };
      return state;
    },
    saveState: function() {
      let self = this;
      let state = self.coreSaveState();
      const ls = window.sessionStorage;
      if (ls != null) {
        ls.setItem(this.getStoreKey(), JSON.stringify(state));
      }
    },
    saveStorageState: function () {
      let self = this;
      let state = self.coreSaveState();
      const store = new LocalStorage(this.controlName + '-filtersettings');
      store.save(this.getStoreKey(true), JSON.stringify(state));
    },
    getState() {
      const ls = window.sessionStorage;
      const localStorageIdentifier = this.getStoreKey();
      let lastfilter = JSON.parse(ls.getItem(localStorageIdentifier));
      return lastfilter;
    },
    clearStorageState() {
      const store = new LocalStorage(this.controlName + '-filtersettings');
      store.save(this.getStoreKey(true), null);
    },
    getStorageState() {
      const store = new LocalStorage(this.controlName + '-filtersettings');
      const localStorageIdentifier = this.getStoreKey(true);
      let lastfilter = JSON.parse(store.get(localStorageIdentifier));
      return lastfilter;
    },
    /**
     * Restore the last used filter from session storage
     * Returns false if no filter is restored
     */
    restoreState: function(fromPinnedFilter) {
      const self = this;
      let lastfilter = (this.pinnedFilter && fromPinnedFilter) ? this.getStorageState() : this.getState();
      if (lastfilter != null) {
        self.flexGridLayout = {
          Sort: lastfilter.filter.order,
          PageSize: lastfilter.filter.pageSize,
          Columns: lastfilter.filter.flexGridLayoutColumns
        };

        self.selectedDataSource = lastfilter.filter.dataSource;
        self.columnFilter = lastfilter.filter.columnFilter;
        self.dataFilter = lastfilter.filter.dataFilter;
        self.urlFilters = lastfilter.filter.urlFilters;
        self.complexFilters = lastfilter.filter.complexFilters;

        for (var f in self.dataFilter) {
          let found = self.filters.find(x => x.selector === f.toString());
          if (found && found.selectedKey !== self.dataFilter[f]) {
            this.$set(found, 'selectedKey', parseInt(self.dataFilter[f]));
          }
        }

        self.dateFilters.forEach(df => {
          let index = self.dateFilters.indexOf(df);
          let found = lastfilter.filter.dateFilters[index];
          
          if (found && found.selectedDate) {
            this.$set(df, 'selectedDate', new Date(found.selectedDate));
          }
        });
        
        this.$set(self, 'pageSize', lastfilter.filter.pageSize);
        this.$set(self, 'selectedPage', lastfilter.filter.pageIndex + 1);
        this.$set(self, 'orderBy', lastfilter.filter.order);
        this.$set(
          self,
          'searchExpressions',
          lastfilter.filter.searchExpressions
        );
        if(lastfilter.filter.searchExpressions != null && !lastfilter.filter.searchExpressions.SEARCH){
          this.$emit('custom-search-expression-restore-state', lastfilter.filter.searchExpressions);
        }

        self.gridCols = this.getFilteredLayoutColumns(
          self.flexGridLayout.Columns
        );

        if (!fromPinnedFilter && lastfilter.controller) {
          const restoredController = lastfilter.controller.commands ? new ExtendedGridController(lastfilter.controller.controller, lastfilter.controller.commands) : new GridController(lastfilter.controller.controller);
          self.gridcontroller = restoredController;
        }
        return true;
      }
      return false;
    },
    resetFilters: function() {
      for (let f of this.filters) {
        this.$set(f, 'selectedKey', null);
      }
      for (let f of this.dateFilters) {
        let ref = this.$refs[f.reference][0];
        ref.clearForm();
      }
      this.getData();
    },
    loadMore: function() {
      if (this.gridData.length !== this.selectedPage * this.pageSize) {
        console.warn(
          'loadmore',
          this.selectedPage,
          this.gridData.length,
          'should be',
          this.selectedPage * this.pageSize
        );
      } else {
        this.selectedPage++;
        this.getDataLive(false, false);
      }
    },
    getSelectedRows: function() {
      const { grid } = this.$refs;
      let selectedRows = grid.getSelectedRows();
      return selectedRows;
    },
    isRowSelected: function(entry) {
      const { grid } = this.$refs;
      return grid.isRowSelected(entry);
    },
    toggleRowSelected: function(entry, selected) {
      const { grid } = this.$refs;
      grid.toggleRowSelected(entry, selected);
    },
    setController(controller) {
      this.gridcontroller = controller;
    },
    getLayoutClone() {
      return lodashCloneDeep(this.gridCols);
    },
    listItemDoubleClicked(data) {
      //{ event: event, row: data[0], col: data[1] }
      this.$emit('list-item-double-clicked', data);
    },
    getGridLink (row) {
      return this.config.onListItemClickedOpenUrl ? this.config.onListItemClickedOpenUrl(row) : null;
    }
  },
  computed: {
    filtersButtonTitle: function() {
      let fcount = 0;

      if (this.filters != null && this.filters.length > 0) {
        fcount += this.filters.filter(x => x.selectedKey != null).length;
      }
      if (this.dateFilters != null && this.dateFilters.length > 0) {
        fcount += this.dateFilters.filter(x =>
          utils.isValidDate(new Date(x.selectedDate))
        ).length;
      }

      return this.$t('grid.btn_filters', { 0: fcount });
    },
    filtersActive: function() {
      if (
        (
          this.filters != null &&
          this.filters.length > 0 &&
          this.filters.filter(x => x.selectedKey != null).length > 0
        ) ||
        (
          this.dateFilters != null && 
          this.dateFilters.length > 0 && 
          this.dateFilters.some(x => utils.isValidDate(new Date(x.selectedDate)))
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasDataSources() {
      return this.dataSource !== null && this.dataSource.length > 0;
    },
    multipleSelected: function() {
      return this.selectedCount > 1;
    },
    selectedCount: function() {
      let self = this;
      let selectedItems = self.getSelectedRows();
      return selectedItems.length;
    },
    notAllLoaded () {
      return this.gridData.length < this.gridDataMeta.Count && this.allSelected;
    }
  },
  watch: {
    defaultDataSource: {
      handler: function(newvalue, oldvalue) {
        if (newvalue) this.selectedDataSource = newvalue;
      },
      immediate: true
    },
    defaultSearchExpressions: {
      handler: function(newvalue, oldvalue) {
        if (newvalue) {
          this.searchExpressions = { ...this.searchExpressions, ...newvalue };
        }
      },
      deep: true,
      immediate: true
    },
    totalResults: {
      handler: function(newvalue, oldvalue) {
        this.$emit('total-count-changed', newvalue);
      },
      immediate: true
    }
  },
  updated: function() {
    // update image bootstrap popover
    $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
    $('[data-toggle="popover"]').popover({
      html: true,
      trigger: 'hover',
      placement: 'right',
      container: 'body',
      template:
        '<div class="popover" style="z-index:99999;" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
  }
};
